<template>
  <b-modal
    id="create-flat-modal"
    title="Flat Create Modal"
    centered
    hide-footer
    size="lg"
    @hidden="reset"
    :no-close-on-esc="true"
    :no-close-on-backdrop="true"
    @show="onModalShow"
  >
    <template #modal-title>
      <h2 class="m-0">Flat Create</h2>
    </template>
    <b-form @submit.prevent enctype="multipart/form-data">
      <b-form-group label-for="flat_no">
        <template #label>
          Flat No <span class="text-danger">*</span>
        </template>
        <b-input
          id="flat_no"
          v-model="flat_no"
          placeholder="Flat No"
          v-restrict="regex"
          required
        ></b-input>
      </b-form-group>

      <b-form-group label-for="building">
        <template #label>
          Building <span class="text-danger">*</span>
        </template>
        <v-select
          label="name"
          v-model="building"
          placeholder="Select Building"
          :options="buildings"
          autoscroll
          :clearable="true"
          required
          disabled
        ></v-select>
      </b-form-group>

      <b-form-group label-for="floor">
        <template #label>
          Floor <span class="text-danger">*</span>
        </template>
        <v-select
          label="floor_no"
          v-model="floor"
          placeholder="Select Floor"
          :options="floors"
          autoscroll
          :clearable="true"
          :disabled="!building"
          required
        ></v-select>
      </b-form-group>


      <!-- <b-form-group label-for="owner">
        <template #label>
          Owner (if Any)
        </template>
        <v-select
          label="label"
          v-model="owner"
          placeholder="Select Owner"
          :options="users"
          autoscroll
          :clearable="true"
          required
        ></v-select>
      </b-form-group> -->

      

      <b-form-group class="mt-2 text-right">
        <b-button
          type="submit"
          variant="primary"
          pill
          class="mr-1"
          @click="submit"
        >
          Add Flat
        </b-button>
        <b-button
          type="reset"
          variant="outline-secondary"
          @click="reset"
          pill
        >
          Reset
        </b-button>
      </b-form-group>
    </b-form>
  </b-modal>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import { ValidationProvider, ValidationObserver } from "vee-validate";
import { required } from "@validations";
import util from "@/util.js";
import { quillEditor } from "vue-quill-editor";
import "quill/dist/quill.core.css";
import "quill/dist/quill.snow.css";
import "quill/dist/quill.bubble.css";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";


export default {
  components: {
    ValidationProvider,
    ValidationObserver,
    quillEditor,
  },
  props: { building : Object },
  mixins: [util],
  data() {
    return {
      required,
      flat_no: "",
      regex: /^[a-zA-Z ]*$/,
      buildings: [],
      floors: [],
      floor: "",
      users: [],
      // owner: "",
    };
  },
  methods: {
    ...mapActions({
      createFlat: "appData/createFlat",
      getFloorsDDL: "appData/getFloorsDDL",
      getBuildingsDDL: "appData/getBuildingsDDL",
      // getUsersDDL: "appData/getUsersDDL",
    }),

    async submit() {
      try {
        const formData = new FormData();
        formData.append("flat_no", this.flat_no);
        formData.append("building", this.building.id);
        formData.append("floor", this.floor.id);
        // if (this.owner)
        // {
        //   formData.append("owner", this.owner.id);
        // }
        formData.append("created_by", this.getLoggedInUser.id);
        formData.append("updated_by", this.getLoggedInUser.id);
        const res = await this.createFlat(formData);
        if (res.status === 201) {
          this.$toast(
            {
              component: ToastificationContent,
              props: {
                title: "Flat Added Successfully",
                variant: "success",
                icon: "BellIcon",
              },
            },
            {
              position: "top-right",
            }
          );
          this.reset();
          this.$nextTick(() => {
            this.$bvModal.hide("create-flat-modal");
          });          
          this.$emit("modalClosed");
        }
      } catch (error) {
        this.displayError(error);
      }
    },

    async onModalShow() {
      const buildings = await this.getBuildingsDDL();
      this.buildings = buildings.data;

      const floors = await this.getFloorsDDL();
      this.floors = floors.data;
      this.floors = this.floors.filter(floor => floor.building === this.building.id); 

      // const users = await this.getUsersDDL();
      // this.users = users.data.map(user => ({
      //   ...user,
      //   label: `${user.name} (Mobile: ${user.mobile_number})`,
      //   name: user.name,
      //   id: user.id,
      // }));
    },

    reset() {
      this.flat_no = "";
      this.manager_email = "";
      this.manager_name = null;
      this.manager_phone = "";
    },
  },
  computed: {
    ...mapGetters({ getLoggedInUser: "appData/getLoggedInUser" }),        
  },  
 
};
</script>

<style></style>
